/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={color:{write:[!0,!0,!0,!0],blendMode:"composite"},depth:!1,stencil:!1};export{e as simplePipelineState};
